// extracted by mini-css-extract-plugin
export var logo = "_7q-2";
export var logoWrapper = "_7q-1";
export var strip = "_7q-0";